<template>
	<span>
		<qst-hero></qst-hero>

		<div v-if="isLoading" class="loader-container">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
		</div>


		<div v-if="showStartForm" class="start-message">
			<div class="start-buttons">
				<button @click="fetchSavedForm" class="nav-button">ویرایش پاسخ‌نامه قبلی</button>
				<button @click="fetchNewForm" class="nav-button">پاسخ‌نامه جدید</button>
			</div>
		</div>

		<!-- <v-row align-center justify-center fill-height>
			<v-col class="text-center q-title">
				<h4 class="font-weight-black">{{ isEmpty ? "سوالی برای نمایش وجود ندارد." : title }}</h4>
			</v-col>
		</v-row> -->

		<div v-if="!isEmpty">
			<v-row align-center justify-center fill-height>
				<v-col class="text-center q-title">
					<h4 class="font-weight-black">{{ title }}</h4>
				</v-col>
			</v-row>

			<div v-if="!isOver">
				<div v-if="!showThankYouMessage" class="navigation-buttons">
					<button @click="prevQuestion" :disabled="currentQuestionIndex === 0" class="nav-button">
						<v-icon>mdi-chevron-right</v-icon>
					</button>
					<button @click="nextQuestion" class="nav-button">
						<v-icon>mdi-chevron-left</v-icon>
					</button>
				</div>
			</div>

			<div class="question-container">
				<div v-if="!isOver">
					<h2 v-if="!isEmpty && !showThankYouMessage" class="cur-index">سوال {{ currentQuestionIndex + 1 }} از
						{{
							questions.length }}</h2>
					<p v-if="!showThankYouMessage">{{ currentQuestion.text }}</p>

					<div v-if="!showThankYouMessage">

						<div v-if="currentQuestion.type === 'single-choice'">
							<!-- <div v-for="(option, index) in currentQuestion.options" :key="index"> -->
							<div v-for="(option, idx) in currentQuestion.options"
								:key="currentQuestionIndex + '-' + idx" class="single-choice-option">
								<label>
									<input type="radio" :name="'question-' + currentQuestionIndex" :value="option"
										v-model="answers[currentQuestionIndex].v" />
									{{ option }}
								</label>
							</div>

							<!-- فیلد توضیحات اضافی برای سوالات دارای followup -->
							<div v-if="currentQuestion.followup">
								<textarea v-model="answers[currentQuestionIndex].f" :placeholder="currentQuestion.followupText ||
									'لطفاً توضیحات خود را وارد کنید'" @input="autoResize($event)" :ref="'followupTextarea' + currentQuestionIndex"
									maxlength="500" class=" followup"></textarea>
							</div>
						</div>

						<div v-else-if="currentQuestion.type === 'multiple-choice'">
							<div v-for="(option, idx) in currentQuestion.options"
								:key="currentQuestionIndex + '-' + idx" class="multiple-choice-option">
								<label>
									<input type="checkbox" :name="'question-' + currentQuestionIndex" :value="option"
										v-model="answers[currentQuestionIndex].v" />
									{{ option }}
								</label>
							</div>

							<!-- فیلد توضیحات اضافی برای سوالات دارای followup -->
							<div v-if="currentQuestion.followup">
								<textarea v-model="answers[currentQuestionIndex].f" :placeholder="currentQuestion.followupText ||
									'لطفاً توضیحات خود را وارد کنید'" @input="autoResize($event)" :ref="'followupTextarea' + currentQuestionIndex"
									maxlength="500" class=" followup"></textarea>
							</div>
						</div>

						<div v-else-if="currentQuestion.type === 'text'" class="place-holder">
							<textarea v-model="answers[currentQuestionIndex].v"
								:placeholder="currentQuestion.placeHolder || 'پاسخ خود را وارد کنید'"
								@input="autoResize($event)" :ref="'answerTextarea' + currentQuestionIndex"
								maxlength="500"></textarea>
						</div>

						<div v-else-if="currentQuestion.type === 'email'" class="place-holder">
							<input type="email" v-model="answers[currentQuestionIndex].v"
								:placeholder="currentQuestion.placeHolder || 'ایمیل خود را وارد کنید'" maxlength="100"
								inputmode="email" dir="ltr" :ref="'answerTextarea' + currentQuestionIndex"
								style="width:100%;padding:3px 7px;background-color:aliceblue;" />
						</div>
						<!-- موبایل -->
						<div v-else-if="currentQuestion.type === 'mobile'" class="place-holder">
							<input type="tel" v-model="answers[currentQuestionIndex].v"
								:placeholder="currentQuestion.placeHolder || 'شماره موبایل را وارد کنید (مثلاً 09123456789)'"
								maxlength="11" pattern="^09\d{9}$" inputmode="numeric" dir="ltr"
								:ref="'answerTextarea' + currentQuestionIndex"
								style="width:100%;padding:3px 7px;background-color:aliceblue;" />
						</div>

						<!-- تلفن ثابت -->
						<div v-else-if="currentQuestion.type === 'phone'" class="place-holder">
							<input type="tel" v-model="answers[currentQuestionIndex].v"
								:placeholder="currentQuestion.placeHolder || 'شماره تلفن را وارد کنید (مثلاً 02112345678)'"
								pattern="^\d{4,}$" inputmode="numeric" dir="ltr"
								:ref="'answerTextarea' + currentQuestionIndex"
								style="width:100%;padding:3px 7px;background-color:aliceblue;" />
						</div>
					</div>

				</div>

				<!-- پیام تشکر نهایی -->
				<div v-if="isOver" class="final-thank-you-message">
					<p>از شما بابت تکمیل پرسشنامه سپاسگزاریم!</p>
					<div class="thank-you-buttons">
						<button @click="editAnswers" class="nav-button">ویرایش پاسخ‌ها</button>
						<button v-if="!isLinkPrivate" @click="fetchNewForm" class="nav-button">پاسخ‌نامه جدید</button>
					</div>
				</div>
			</div>

		</div>

		<!-- Snackbar برای نمایش پیام -->
		<v-snackbar v-model="snackbar" :timeout="3000" color="red" top>
			{{ snackbarMessage }}
		</v-snackbar>
	</span>
</template>


<script>
import CryptoJS from "crypto-js";
import QstHero from "@/components/QstHero";
// import testQ from "../../data/q1-v1.json";
import testQ from "../../data/q4.json";

export default {
	name: "Qst",
	components: {
		QstHero,
	},
	data() {
		return {
			testLocalQst: false,
			savedId: null,
			questions: [],
			currentQuestionIndex: 0,
			answers: [{ v: "", f: "" }],
			showThankYouMessage: false,
			isSubmitted: false,
			isOver: false,
			isLinkPrivate: false,
			qstId: null,
			cntCode: null,
			linkSig: null,
			linkRefCode: null,
			linkToken: null,
			userName: "",
			snackbar: false,
			snackbarMessage: "",
			isLoading: true,
			title: "پرسشنامه",
			showStartForm: false,
			lastSavedAnswers: null,
		};
	},
	watch: {
		'answers': {
			handler() {
				this.$nextTick(() => {
					// پاسخ اصلی
					const refName = 'answerTextarea' + this.currentQuestionIndex;
					const textarea = this.$refs[refName];
					if (textarea) {
						const el = Array.isArray(textarea) ? textarea[0] : textarea;
						el.style.height = 'auto';
						el.style.height = el.scrollHeight + 'px';
					}
					// followup
					const followupRef = 'followupTextarea' + this.currentQuestionIndex;
					const followup = this.$refs[followupRef];
					if (followup) {
						const el = Array.isArray(followup) ? followup[0] : followup;
						el.style.height = 'auto';
						el.style.height = el.scrollHeight + 'px';
					}
				});
			},
			deep: true
		}
	},
	computed: {
		currentQuestion() {
			return (this.currentQuestionIndex < this.questions.length) ? this.questions[this.currentQuestionIndex] : {}
			// { text: "سوالی برای نمایش وجود ندارد.", type: "caption", options: [], isRequired: false, followup: false, placeHolder: "" };
		},
		isEmpty() {
			return this.questions.length === 0;
		},
	},
	methods: {
		// همان قالبی که decryptQstData در بک‌اند انتظار دارد: aes-256-cbc با کلید sha256(secretKey) و { iv, data } به صورت base64
		encryptPayload(body, secretKey) {
			const key = CryptoJS.SHA256(secretKey);
			const iv = CryptoJS.lib.WordArray.random(16);
			const encrypted = CryptoJS.AES.encrypt(body, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
			return {
				iv: CryptoJS.enc.Base64.stringify(iv),
				data: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
			};
		},
		// امتیاز پاسخ از روی جایگاه گزینه در options و مقدار هم‌جایگاه در scores؛ چند گزینه‌ای = جمع امتیازها
		answerScore(question, answer) {
			if (!question || !Array.isArray(question.options) || !Array.isArray(question.scores) || !answer) return null;
			const values = Array.isArray(answer.v) ? answer.v : [answer.v];
			const scores = values
				.map(v => question.scores[question.options.indexOf(v)])
				.filter(s => typeof s === 'number');
			return scores.length ? scores.reduce((sum, s) => sum + s, 0) : null;
		},
		autoResize(event) {
			const textarea = event.target;
			textarea.style.height = 'auto';
			textarea.style.height = textarea.scrollHeight + 'px';
		},
		autoResizeAll() {
			// پاسخ اصلی
			const refName = 'answerTextarea' + this.currentQuestionIndex;
			const textarea = this.$refs[refName];
			if (textarea) {
				const el = Array.isArray(textarea) ? textarea[0] : textarea;
				el.style.height = 'auto';
				el.style.height = el.scrollHeight + 'px';
			}
			// followup
			const followupRef = 'followupTextarea' + this.currentQuestionIndex;
			const followup = this.$refs[followupRef];
			if (followup) {
				const el = Array.isArray(followup) ? followup[0] : followup;
				el.style.height = 'auto';
				el.style.height = el.scrollHeight + 'px';
			}
		},
		// isComplete() {
		// 	return this.questions.every((question, index) => {
		// 		if (question.isRequired) {
		// 			const answer = this.answers[this.currentQuestionIndex];
		// 			if (!answer) return false;
		// 			if (this.currentQuestion.type === 'multiple-choice') {
		// 				return Array.isArray(answer.v) && answer.v.length > 0;
		// 			}
		// 			return answer.v !== undefined && answer.v !== "";
		// 		}
		// 		return true;
		// 	});
		// },
		isComplete() {
			return this.questions.every((question, index) => {
				if (question.isRequired) {
					const answer = this.answers[index];
					if (!answer) return false;
					if (question.type === 'multiple-choice') {
						return (Array.isArray(answer.v) && answer.v.length > 0) || (answer.f && answer.f.trim() !== "");
					}
					return (answer.v !== undefined && answer.v !== "") || (answer.f && answer.f.trim() !== "");
				}
				return true;
			});
		},
		// isCurrentQuestionAnswered() {
		// 	const answer = this.answers[this.currentQuestionIndex];
		// 	if (!answer) return false;
		// 	if (this.currentQuestion.type === 'multiple-choice') {
		// 		return Array.isArray(answer.v) && answer.v.length > 0;
		// 	}
		// 	return answer.v !== undefined && answer.v !== "";
		// },
		isCurrentQuestionAnswered() {
			const answer = this.answers[this.currentQuestionIndex];
			if (!answer) return false;
			if (this.currentQuestion.type === 'multiple-choice') {
				return (Array.isArray(answer.v) && answer.v.length > 0) || (answer.f && answer.f.trim() !== "");
			}
			return (answer.v !== undefined && answer.v !== "") || (answer.f && answer.f.trim() !== "");
		},
		async fetchQstData() {
			// try {
			const apiUrl = process.env.VUE_APP_GET_QST_INFO;
			const pazarSecretKey = process.env.VUE_APP_PCL_SECRET_KEY;
			// console.info(apiUrl);

			// --
			let payload = { id: this.savedId, questionId: this.qstId, contactCode: this.cntCode, refCode: this.linkRefCode, sig: this.linkSig, token: this.linkToken };

			// --
			// const body = JSON.stringify(payload)
			// const response = await fetch(apiUrl, {
			// 	method: "POST",
			// 	headers: { "Content-Type": "application/json", },
			// 	body,
			// });

			// ... در submitAnswers:
			const body = JSON.stringify(payload)
			const encryptedBody = this.encryptPayload(body, pazarSecretKey);
			// const encryptedBody = encrypt(body)
			// function encrypt(body) {
			// 	const secretKey = crypto.createHash('sha256').update(pazarSecretKey).digest(); // کلید 32 بایتی
			// 	const iv = crypto.randomBytes(16); // IV رندوم
			// 	const cipher = crypto.createCipheriv("aes-256-cbc", secretKey, iv);
			// 	let encrypted = cipher.update(body, "utf8", "base64");
			// 	encrypted += cipher.final("base64");
			// 	return {
			// 		iv: iv.toString("base64"),
			// 		data: encrypted
			// 	};
			// }

			const response = await fetch(apiUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ data: encryptedBody }),
			});
			// console.info(response);
			if (response.ok) {
				const rsp = await response.json();
				console.info('rsp', rsp);
				if (rsp.status === 'REJECT' && rsp.msg) {
					this.snackbarMessage = rsp.msg;
					this.snackbar = true;
				}
				const contact = rsp.data && rsp.data.contact ? rsp.data.contact : {}

				const qstData = rsp.data && rsp.data.question ? rsp.data.question : {}
				const savedAnswers = rsp.data && rsp.data.answer ? rsp.data.answer : []

				this.title = qstData.title || "پرسشنامه";
				if (!this.testLocalQst) this.questions = qstData.data ? qstData.data : [];

				// --
				this.lastSavedAnswers = JSON.parse(JSON.stringify(this.answers));

				// -- default answers
				// this.answers = this.questions.map(q => ({ v: q.defaultValue || "", f: "" }));
				this.answers = this.questions.map(q =>
					q.type === 'multiple-choice'
						? { v: [], f: "" }
						: { v: q.defaultValue || "", f: "" }
				);

				// -- confirm user information
				for (let index = 0; index < this.questions.length; index++) {
					const q = this.questions[index];
					// this.answers[index] = { v: q.defaultValue || "", f: "" };
					if (contact[q.propName]) {
						this.answers[index].v = (contact[q.propName]);
					}
				}

				// -- savedAnswers
				// for (let index = 0; index < savedAnswers.length; index++) {
				// 	const r = savedAnswers[index];
				// 	this.answers[index] = { v: r.v || "", f: r.f || "" };
				// }
				for (let index = 0; index < savedAnswers.length; index++) {
					const q = this.questions[index];
					const r = savedAnswers[index];
					this.answers[index] = {
						v: (q && q.type === 'multiple-choice')
							? (Array.isArray(r.v) ? r.v : (r.v ? [r.v] : []))
							: (r.v || ""),
						f: r.f || ""
					};
				}

				// console.info('rsp-answers', rsp, this.answers)
			} else {
				console.error("خطا در دریافت اطلاعات کاربر:", response.statusText);
			}
			// } catch (error) {
			// 	console.error("خطا در دریافت اطلاعات کاربر:", error);

			// } finally {
			// 	this.isLoading = false; // پنهان کردن لودر پس از دریافت پاسخ
			// }
			this.isLoading = false; // پنهان کردن لودر پس از دریافت پاسخ
		},
		checkValidation() {

			if (this.isCurrentQuestionAnswered()) {
				// اگر نوع سوال ایمیل است، اعتبارسنجی انجام بده
				if (this.currentQuestion.type === 'email') {
					const email = this.answers[this.currentQuestionIndex].v;
					const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailRegex.test(email)) {
						this.snackbarMessage = "لطفاً یک ایمیل معتبر وارد کنید.";
						this.snackbar = true;
						return false;
					}
				}

				// اعتبارسنجی موبایل (مثال: ایران، 09xxxxxxxxx)
				if (this.currentQuestion.type === 'mobile') {
					const mobile = this.answers[this.currentQuestionIndex].v;
					const mobileRegex = /^$|^09\d{9}$/;
					if (!mobileRegex.test(mobile)) {
						this.snackbarMessage = "لطفاً یک شماره موبایل معتبر وارد کنید (مثلاً 09123456789).";
						this.snackbar = true;
						return false;
					}
				}

				// اعتبارسنجی تلفن ثابت (مثال: 021xxxxxxx یا 0xxxxxxxxxx)
				if (this.currentQuestion.type === 'phone') {
					const phone = this.answers[this.currentQuestionIndex].v;
					const phoneRegex = /^$|^\d{4,}$/;
					if (!phoneRegex.test(phone)) {
						this.snackbarMessage = "لطفاً یک شماره تلفن معتبر وارد کنید (مثلاً 02112345678).";
						this.snackbar = true;
						return false;
					}
				}
			}
			return true;
		},
		async prevQuestion() {
			if (this.currentQuestionIndex > 0) {
				if (!this.checkValidation()) return
				await this.submitAnswers()

				this.currentQuestionIndex--;
				this.showThankYouMessage = false;
				this.$nextTick(() => this.autoResizeAll());
			}
		},
		async nextQuestion() {
			if (this.currentQuestion.isRequired && !this.isCurrentQuestionAnswered()) {
				this.snackbarMessage = "لطفاً ابتدا به این سوال پاسخ دهید.";
				this.snackbar = true;
				return;
			}

			if (!this.checkValidation()) return
			await this.submitAnswers()

			if (this.currentQuestionIndex < this.questions.length - 1) {
				// --
				this.currentQuestionIndex++;
				this.$nextTick(() => this.autoResizeAll());

			} else {
				this.isOver = true;
				this.showThankYouMessage = true;
				// اگر به آخرین سوال رسیده و همه سوالات الزامی پاسخ داده شده‌اند
				// if (this.isComplete()) {
				// 	this.showThankYouMessage = true;
				// } else {
				// 	this.snackbarMessage = "لطفاً به تمام سوالات الزامی پاسخ دهید.";
				// 	this.snackbar = true;
				// }
			}
		},
		editAnswers() {
			this.currentQuestionIndex = 0;
			this.showThankYouMessage = false;
			this.isOver = false;
		},
		// newForm() {
		// 	this.savedId = null;
		// 	localStorage.removeItem(`qHv${this.qstId || this.linkToken}`);
		// 	this.currentQuestionIndex = 0;
		// 	this.showThankYouMessage = false;
		// 	this.isOver = false;
		// 	if (!this.isLinkPrivate) this.createNewUserId()
		// },
		async submitAnswers() {
			try {
				if (!this.isComplete()) {
					return
				}

				// --
				const changed = JSON.stringify(this.answers) !== JSON.stringify(this.lastSavedAnswers);
				if (!changed) {
					return
				}

				// --
				// امتیاز (s) همان لحظه از scores پرسشنامه ثبت می‌شود تا با تغییر بعدی پرسشنامه عوض نشود
				const processedAnswers = this.questions.map((question, index) => {
					const answer = this.answers[index];
					const s = this.answerScore(question, answer);
					return s === null ? answer : { ...answer, s };
				});

				// --
				const apiUrl = process.env.VUE_APP_SAVE_QST_RESPOND;
				const secretKey = process.env.VUE_APP_PCL_SECRET_KEY;
				const payload = {
					id: this.savedId || null,
					questionId: this.qstId,
					contactCode: this.cntCode,
					refCode: this.linkRefCode,
					sig: this.linkSig,
					token: this.linkToken,
					data: processedAnswers,
					timestamp: new Date().toISOString(),
				};

				this.isLoading = true;
				const body = JSON.stringify(payload)
				// const response = await fetch(apiUrl, {
				// 	method: "POST",
				// 	headers: { "Content-Type": "application/json", },
				// 	body,
				// });

				// --
				const encryptedBody = this.encryptPayload(body, secretKey);

				const response = await fetch(apiUrl, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ data: encryptedBody }),
				});

				const rsp = await response.json();
				this.isLoading = false;
				console.info(rsp);

				// --
				if (response.ok) {
					this.lastSavedAnswers = JSON.parse(JSON.stringify(this.answers));

					// --
					this.savedId = rsp.data && rsp.data.savedId ? rsp.data.savedId : this.savedId;

					// --
					const encryptedId = btoa(this.savedId.toString());
					localStorage.setItem(`qHv${this.qstId || this.linkToken}`, encryptedId);
				}

				// --
				if (this.isOver) {
					if (response.ok) {
						this.isSubmitted = true;
					} else {
						console.error("خطا در ارسال پاسخ‌ها:", response.statusText);
						this.snackbarMessage = "ارسال پاسخ‌ها با خطا مواجه شد.";
						this.snackbar = true;
					}
				}
			} catch (error) {
				if (this.isOver) {
					console.error("خطا در ارسال پاسخ‌ها:", error);
					this.snackbarMessage = "ارسال پاسخ‌ها با خطا مواجه شد.";
					this.snackbar = true;
				}
			}
		},
		createNewUserId() {
			this.cntCode = 'u' + Math.random().toString(36).substring(2, 6) + Math.random().toString(36).substring(2, 6);
			// console.info('New cntCode created:', this.cntCode);
		},
		async fetchSavedForm() {
			this.isLoading = true;
			const decryptedId = localStorage.getItem(`qHv${this.qstId || this.linkToken}`);
			if (decryptedId) this.savedId = parseInt(atob(decryptedId), 10);
			// this.savedId = parseInt(localStorage.getItem(`qHv${this.qstId || this.linkToken}`), 10)
			if (this.savedId) {
				await this.fetchQstData();
				this.showStartForm = false;
			} else {
				this.snackbarMessage = "هیچ پاسخ‌نامه‌ای برای ویرایش وجود ندارد.";
				this.snackbar = true;
			}
			this.isLoading = false;
		},
		async fetchNewForm() {
			this.isOver = false;
			this.currentQuestionIndex = 0;
			this.showThankYouMessage = false;
			this.isLoading = true;
			this.savedId = null;
			localStorage.removeItem(`qHv${this.qstId || this.linkToken}`);
			await this.fetchQstData();
			this.showStartForm = false;
			this.isLoading = false;
		},
	},
	async mounted() {
		// console.info(this.$route)
		// this.qstId = this.$route.query.i || null;
		// this.cntCode = this.$route.query.c || null;

		const params = this.$route.params || {};
		const pathMatch = params.pathMatch || "";
		const parts = (pathMatch.split("/")[1] || "").split(".");
		const param = parts[0] || "";
		if (parts.length === 1 && /^[A-Za-z0-9_-]{18}$/.test(param)) {
			// لینک کوتاه CRM: توکن 18 کاراکتری — پرسشنامه، مخاطب و روز پشتیبانی را فقط بک‌اند از آن بیرون می‌آورد
			this.linkToken = param;
			this.qstId = null;
			this.cntCode = null;
		} else {
			// لینک اختصاصی قدیمی: {کد}.{روز پشتیبانی}.{امضا} (یا {کد}.{امضا}) — امضا را CRM می‌سازد و بک‌اند بررسی می‌کند
			this.linkRefCode = parts.length > 2 ? parts[1] : null;
			this.linkSig = parts.length > 1 ? parts[parts.length - 1] || null : null;
			this.qstId = param.substring(2, 6);
			this.cntCode = param.substring(0, 2) + param.substring(6);
		}
		// console.info('qstId:', this.qstId, 'cntCode:', this.cntCode);

		this.isLinkPrivate = !!this.linkToken || (this.cntCode && this.cntCode.length > 6);
		if (!this.isLinkPrivate) {
			this.createNewUserId()
		}

		// --
		this.questions = (this.testLocalQst) ? testQ || [] : [];

		const decryptedId = localStorage.getItem(`qHv${this.qstId || this.linkToken}`);
		const lclSavedId = (decryptedId) ? parseInt(atob(decryptedId), 10) : null;
		// const lclSavedId = localStorage.getItem(`qHv${this.qstId || this.linkToken}`)
		if (!this.isLinkPrivate && lclSavedId) {
			// this.savedId = parseInt(lclSavedId, 10);
			// console.info('lclSavedId:', this.savedId);
			this.showStartForm = true;
		} else {
			await this.fetchNewForm();
		}
		this.isLoading = false;
	},
};
</script>
<style scoped>
.question-container {
	margin-inline: 20px;
	padding: 20px;
	border: 1px solid #ddd;
	border-radius: 8px;
	background-color: #f9f9f9;
	white-space: pre-line;
	max-width: calc(100% - 40px);
	width: 100%;
	min-height: 280px;
}

.q-title {
	margin-block: 20px;
}

.loader-container {
	position: fixed;
	justify-content: center;
	align-items: center;
	height: 100%;
	display: flex;
	top: 0;
	width: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	z-index: 1000;
}

textarea {
	width: 100%;
	white-space: pre-line;
	resize: none;
	/* overflow-y: hidden; */
	min-height: 50px;
	box-sizing: border-box;
	padding: 3px 7px;
	background-color: aliceblue;
	/* max-height: 250px; */
}

.multiple-choice-option,
.single-choice-option {
	margin-bottom: 10px;
}

.followup {
	margin-top: 20px;
}

.cur-index {
	text-align: right;
	font-size: 12px;
	color: #333;
	margin-bottom: 10px;
}

.navigation-buttons {
	display: flex;
	margin-bottom: 10px;
	justify-content: center;
	/* margin-inline-start: 70px; */
}

.nav-button {
	background-color: darkseagreen;
	color: white;
	border: none;
	border-radius: 4px;
	padding: 10px 20px;
	cursor: pointer;
	margin-inline: 20px;
}

.nav-button:disabled {
	background-color: #ccc;
	cursor: not-allowed;
}

.start-message {
	margin: 20px;
	padding: 50px;
	background-color: #d4edda;
	border: 1px solid #c3e6cb;
	border-radius: 4px;
	color: #155724;
	text-align: center;
	font-size: 18px;
}

.start-buttons {
	display: flex;
	justify-content: center;
	gap: 10px;
	/* margin-top: 20px; */
}

.thank-you-message {
	margin-top: 20px;
	padding: 10px;
	background-color: #e0ffe0;
	border: 1px solid #00a000;
	border-radius: 4px;
	color: #006400;
	text-align: center;
}

.thank-you-buttons {
	display: flex;
	justify-content: center;
	gap: 10px;
	margin-top: 50px;
}

.final-thank-you-message {
	margin: 20px;
	padding: 20px;
	/* background-color: #d4edda; */
	/* border: 1px solid #c3e6cb; */
	border-radius: 4px;
	color: #155724;
	text-align: center;
	font-size: 18px;
}
</style>